import styled from 'styled-components';
import { variant } from 'styled-system';
import { ThemeUtilities } from '../../../theme';
import { ComponentSize } from '../types';
import { BorderVariant, Status, Variant } from './types';
import { iconSize } from './constants';
import { fontSmoothing } from '../../../mixins';

export const StyledSelect = styled.input<{
  selectSize: ComponentSize;
  selectVariant: Variant;
  status: Status;
  borderVariant: BorderVariant;
}>`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid currentColor;
  outline: none;
  transition: border-color 250ms ease-in-out, box-shadow 250ms ease-in-out,
    background-color 250ms ease-in-out;
  will-change: border-color, box-shadow, background-color;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  ${fontSmoothing};

  &:read-only {
    cursor: pointer;
  }

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Select', 'selectSize'))};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Select', 'selectVariant')
    )};
  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'Select', 'borderVariant')
    )};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Select', 'status'))};

  padding-right: ${({ theme, selectSize }) =>
    theme.space[
      theme.components.Select.componentVariants.selectSize.variants[selectSize]
        .paddingRight
    ] + iconSize}px;
`;

export const SelectWrapper = styled.div`
  position: relative;
`;

export const FocusHandler = styled.div`
  width: 0;
  height: 0;
`;
